const productsReducer = (state = null, action) => {
  switch(action.type) {
    case 'TEST_ACTION':
      console.log('Test action reducer!');
      return state;
    case 'CLEAR_PRODUCTS':
      return [];
    case 'LOAD_PRODUCTS':
      return state.concat(action.products);
    default:
      return state;
  }
};

export default productsReducer

